import { Box, Button, Modal } from "@mui/material";
import React from "react";
import DropDownComponent from "../DropDownComponent";
import { useState } from "react";
import { db } from "../../firebase";
import { collection, doc, onSnapshot, setDoc } from "firebase/firestore";
import { useEffect } from "react";
import UpdloaderPsychosocial from "../Updloader/UpdloaderPsychosocial";
import { showCustomToast } from "../Misc/CustomToast";
import AddTreatmentPlan from "../forms/AddTreatmentPlan";
import { format } from "date-fns";
import AddGeneralLiabilityForm from "../forms/AddGeneralLiabilityForm";
import AddInformedConsentForm from "../forms/AddInformedConsentForm";
import AddPsychiatristServicesForm from "../forms/AddPsychiatristServicesForm";
import AddConfidentialityPolicy from "../forms/AddConfidentialityPolicy";
import AddClientRights from "../forms/AddClientRights";
import AddAgressionControl from "../forms/AddAgressionControl";
import AddDischargeReport from "../forms/AddDischargeReport";
import EditDischargeReport from "../forms/EditDischargeReport";
import AddAcaForm from "../forms/AddAcaForm";
import AddEmergencyDischargeForm from "../forms/AddEmergencyDischargeForm";
import ViewDischargeReport from "../forms/ViewDischargeReport";
import ViewAcaReport from "../forms/ViewAcaReport";
import ViewEmergencyDischargeReport from "../forms/ViewEmergencyDischargeReport";
import InputComponent from "../InputComponent";
import UpdloaderTreatmentPlan from "../Updloader/UpdloaderTreatmentPlan";
import UploaderBioPsychoModern from "../Updloader/UploaderBioPsychoModern";
import UploaderTreatmentPlanModern from "../Updloader/UploaderTreatmentPlanModern";
import AddBioPsycho3 from "../forms/AddBioPsycho3";
import AddContinuatedTherapySupport from "../forms/AddContinuatedTherapySupport";
import FormLineConsAgreeUnsupervised from "../Lines/FormLineConsAgreeUnsupervised";
import AddConsentAgreementUnsupervisedActivityGood from "../forms/AddConsentAgreementUnsupervisedActivityGood";
import AddConsentSelfOutingPrivilege from "../forms/AddConsentSelfOutingPrivilege";
import FormLineOutingPrivilege from "../Lines/FormLineOutingPrivilege";
import ViewConsentAgreementUnsupervisedActivities from "../forms/ViewConsentAgreementUnsupervisedActivities";
import ViewSelfoutingPrivileges from "../forms/ViewSelfOutingPrivileges";
import { incrementDailyReads } from "../../logsComponents/incrementDailyReads";
import Chip from "@mui/material/Chip";
import StandardDrawer from "../forms/StandardDrawer";
import CheckWithDate from "../CheckWithDate";
import "./BioPsychoUploadLayout.css";

function ClinicalInformations(props) {
  const styleModalUploadPdf = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "80%",
    borderRadius: 5,
    backgroundColor: "white",
    boxShadow: 24,
  };

  const styleModalGeneral = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "80%",
    borderRadius: 5,
    // overflowY: "scroll",
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const styleModalGeneral2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "80%",
    borderRadius: 5,
    // overflowY: "scroll",
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  // USESTATE

  // juste après vos useState existants
  const [corePlanData, setCorePlanData] = useState(null);

  // à la suite de vos autres useEffect, par exemple
  useEffect(() => {
    const unsubscribeCorePlan = onSnapshot(
      doc(db, "CoreTreatmentPlans", props.clientId),
      (docSnap) => {
        if (docSnap.exists()) {
          setCorePlanData(docSnap.data());
          try { incrementDailyReads("profile_clinical_corePlan", 1); } catch {}
        } else {
          setCorePlanData(null);
        }
      },
      (error) => {
        console.error("Error fetching core treatment plan:", error);
      }
    );

    return () => {
      unsubscribeCorePlan();
    };
  }, [props.clientId]);

  const [isModified, setIsModified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [primaryAddiction, setPrimaryAddiction] = useState(
    props.primaryAddiction || ""
  );
  const [secondaryAddiction, setSecondaryAddiction] = useState(
    props.secondaryAddiction || ""
  );
  const [allergy, setAllergy] = useState(props.allergy || "");
  const [drugAllergy, setDrugAllergy] = useState(props.drugAllergy || "");
  const [currentLegalInvolvement, setCurrentLegalInvolvement] = useState(
    props.currentLegalInvolvement || ""
  );
  const [otherMajorHealthIssues, setOtherMajorHealthIssues] = useState(
    props.otherMajorHealthIssues || ""
  );
  const [primaryAddictionOther, setPrimaryAddictionOther] = useState(
    props.addictionOther || ""
  );
  const [secondaryAddictionOther, setSecondaryAddictionOther] = useState(
    props.secondaryAddictionOther || ""
  );
  const [allergyOther, setAllergyOther] = useState(props.allergyOther || "");

  const [drugAllergyOther, setDrugAllergyOther] = useState(
    props.drugAllergyOther || ""
  );
  const [openUploadBioPsycho2, setOpenUploadBioPsycho2] = useState(false);
  const [openBioPsycho3, setOpenBioPsycho3] = useState(false);
  const [openUploadTreatmentPlan, setOpenUploadTreatmentPlan] = useState(false);
  const [openTreatmentPlanForm, setOpenTreatmentPlanForm] = useState(false);
  const [, setTreatmentPlanCreationDate] = useState(null);
  const [, setTreatmentPlanCreationBy] = useState("");
  const [, setPresentingIssues] = useState("");
  const [dischargeReportOkState, setDischargeReportOkState] = useState(
    props.DischargeReportOk || false
  );
  const [dischargeReportDateState, setDischargeReportDateState] = useState(
    props.DischargeReportDateSigned || null
  );
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log("Discharge props:", {
      DischargeReportOk: props.DischargeReportOk,
      DischargeReportDateSigned: props.DischargeReportDateSigned,
    });
  }, [props.DischargeReportOk, props.DischargeReportDateSigned]);

  // Keep discharge flags in sync with Firestore
  useEffect(() => {
    if (!props.clientId) return;
    const unsub = onSnapshot(doc(db, "clients", props.clientId), (snap) => {
      if (snap.exists()) {
        const data = snap.data();
        setDischargeReportOkState(!!data.DischargeReportOk);
        setDischargeReportDateState(data.DischargeReportDateSigned || null);
      }
    });
    return () => unsub();
  }, [props.clientId]);
  const [, setLongTermGoals] = useState("");
  const [, setObjectives] = useState([]);
  const [, setReviewDone] = useState(false);
  const [, setReviewDoneAt] = useState(null);
  const [, setReviewDoneBy] = useState("");
  const [openGeneralLiabilityForm, setOpenGeneralLiabilityForm] =
    useState(false);
  const [openInformedConsentForm, setOpenInformedConsentForm] = useState(false);
  const [openPsychiatricServicesForm, setOpenPsychiatricServicesForm] =
    useState(false);
  const [openClientRightsForm, setOpenClientRightsForm] = useState(false);
  const [openAgressionPolicyForm, setOpenAgressionPolicyForm] = useState(false);
  const [openConfidentialityPolicyForm, setOpenConfidentialityPolicyForm] =
    useState(false);
  const [openDischargeSummaryForm, setOpenDischargeSummaryForm] =
    useState(false);
  const [openAcaForm, setOpenAcaForm] = useState(false);
  const [openEmergencyDischargeForm, setOpenEmergencyDischargeForm] =
    useState(false);
  const [openViewDischargeSummaryForm, setOpenViewDischargeSummaryForm] =
    useState(false);
  const [openEditDischargeSummaryForm, setOpenEditDischargeSummaryForm] =
    useState(false);
  const [openViewAcaForm, setOpenViewAcaForm] = useState(false);
  const [openViewEmergencyDischargeForm, setOpenViewEmergencyDischargeForm] =
    useState(false);
  const [consentsUnsupervised, setConsentsUnsupervised] = useState([]);
  const [selfOutingPrivileges, setSelfOutingPrivileges] = useState([]);
  const [openAddUnsupervised, setOpenAddUnsupervised] = useState(false);
  const [openAddSelfOuting, setOpenAddSelfOuting] = useState(false);
  const [bioStatus, setBioStatus] = useState({ label: "Not filled", color: "#d32f2f" });

  const handleCloseAddUnsupervised = () => setOpenAddUnsupervised(false);
  const handleCloseAddSelfOuting = () => setOpenAddSelfOuting(false);
  const handleOpenAddUnsupervised = () => setOpenAddUnsupervised(true);
  const handleOpenAddSelfOuting = () => setOpenAddSelfOuting(true);

  const handleCloseBioPsychoForm2 = () => setOpenUploadBioPsycho2(false);

  const handleCloseTreatmentPlan2 = () => setOpenUploadTreatmentPlan(false);
  const [
    openContinuatedTherapySupportForm,
    setOpenContinuatedTherapySupportForm,
  ] = useState(false);

  // états pour l’ouverture des modals “view”
  const [openViewUnsupervised, setOpenViewUnsupervised] = useState(false);
  const [selectedUnsupervisedId, setSelectedUnsupervisedId] = useState(null);

  const [openViewSelfOuting, setOpenViewSelfOuting] = useState(false);
  const [selectedSelfOutingId, setSelectedSelfOutingId] = useState(null);

  // handlers pour ouvrir/fermer les modals view
  const handleOpenViewUnsupervised = (id) => {
    setSelectedUnsupervisedId(id);
    setOpenViewUnsupervised(true);
  };
  const handleCloseViewUnsupervised = () => {
    setOpenViewUnsupervised(false);
    setSelectedUnsupervisedId(null);
  };

  const handleOpenViewSelfOuting = (id) => {
    setSelectedSelfOutingId(id);
    setOpenViewSelfOuting(true);
  };
  const handleCloseViewSelfOuting = () => {
    setOpenViewSelfOuting(false);
    setSelectedSelfOutingId(null);
  };

  //HANDLE FUNCTIONS

  const handlePrimaryAddictionOther = (event) => {
    setIsModified(true);
    setPrimaryAddictionOther(event);
  };

  const handleSecondaryAddictionOther = (event) => {
    setIsModified(true);
    setSecondaryAddictionOther(event);
  };

  const handleAllergyOther = (event) => {
    setIsModified(true);
    setAllergyOther(event);
  };

  const handlePrimaryAddictionChange = (event) => {
    setIsModified(true);
    setPrimaryAddiction(event);
  };
  const handleSecondaryAddictionChange = (event) => {
    setIsModified(true);
    setSecondaryAddiction(event);
  };
  const handleAllergyChange = (event) => {
    setIsModified(true);
    setAllergy(event);
  };
  const handleDrugAllergyChange = (event) => {
    setIsModified(true);
    setDrugAllergy(event);
  };

  const handleOpenTreatmentPlanForm = () => setOpenTreatmentPlanForm(true);
  const handleCloseTreatmentPlanForm = () => setOpenTreatmentPlanForm(false);
  const handleCloseGeneralLiabilityForm = () =>
    setOpenGeneralLiabilityForm(false);
  const handleCloseInformedConsentForm = () =>
    setOpenInformedConsentForm(false);
  const handleClosePsychiatricServicesForm = () =>
    setOpenPsychiatricServicesForm(false);
  const handleCloseConfidentialityPolicyForm = () =>
    setOpenConfidentialityPolicyForm(false);
  const handleCloseClientRightsForm = () => setOpenClientRightsForm(false);
  const handleCloseAgressionPolicyForm = () =>
    setOpenAgressionPolicyForm(false);
  const handleCloseDischargeSummaryForm = () =>
    setOpenDischargeSummaryForm(false);
  const handleCloseAcaForm = () => setOpenAcaForm(false);
  const handleCloseEmergencyDischargeForm = () =>
    setOpenEmergencyDischargeForm(false);
  const handleCloseViewDischargeSummaryForm = () =>
    setOpenViewDischargeSummaryForm(false);
  const handleCloseEditDischargeSummaryForm = () =>
    setOpenEditDischargeSummaryForm(false);
  const handleCloseViewAcaForm = () => setOpenViewAcaForm(false);
  const handleCloseViewEmergencyDischargeForm = () =>
    setOpenViewEmergencyDischargeForm(false);
  const handleOpenDischargeSummaryForm = () =>
    setOpenDischargeSummaryForm(true);
  const handleOpenAcaForm = () => setOpenAcaForm(true);
  const handleOpenEmergencyDischargeForm = () =>
    setOpenEmergencyDischargeForm(true);
  const handleOpenViewDischargeSummaryForm = () =>
    setOpenViewDischargeSummaryForm(true);
  const handleOpenEditDischargeSummaryForm = () =>
    setOpenEditDischargeSummaryForm(true);
  const handleOpenViewAcaForm = () => setOpenViewAcaForm(true);
  const handleOpenViewEmergencyDischargeForm = () =>
    setOpenViewEmergencyDischargeForm(true);

  const handleOpenBioPsycho3 = () => setOpenBioPsycho3(true);
  const handleCloseBioPsycho3 = () => setOpenBioPsycho3(false);
  const handleCloseContinuatedTherapySupportForm = () =>
    setOpenContinuatedTherapySupportForm(false);

  //USEEFFECT

  useEffect(() => {
    // props.onModificationChange(isModified);
    props.onModificationChange(isModified);
  }, [isModified]);

  useEffect(() => {
    if (!props.clientId) return;
    const bioRef = doc(db, "bioPsychoSocialDigitalForm", props.clientId);
    const unsub = onSnapshot(bioRef, (snap) => {
      if (!snap.exists()) {
        setBioStatus({ label: "Not filled", color: "#d32f2f" });
        return;
      }
      const data = snap.data() || {};
      const required = [
        "summary",
        "historyOfSubstanceAbuseProgression",
        "treatmentGoals",
        "motivationIntrinsicFactors",
        "motivationExtrinsicFactors",
      ];
      const isComplete = required.every((k) => {
        const v = data[k];
        return v !== undefined && v !== null && String(v).trim() !== "";
      });
      const hasAny = Object.values(data).some((v) => {
        if (Array.isArray(v)) return v.length > 0;
        return v !== undefined && v !== null && String(v).trim() !== "";
      });
      if (!hasAny) {
        setBioStatus({ label: "Not filled", color: "#d32f2f" });
      } else if (isComplete) {
        setBioStatus({ label: "Complete", color: "#2e7d32" });
      } else {
        setBioStatus({ label: "Partially filled", color: "#f9a825" });
      }
    });
    return () => unsub();
  }, [props.clientId]);

  // --- fetch dynamic forms ---
  useEffect(() => {
    const colUnsupervised = collection(
      db,
      "clients",
      props.clientId,
      "ConsentAgreementUnsupervisedActivities"
    );
    const unsubscribeUn = onSnapshot(colUnsupervised, (snap) => {
      setConsentsUnsupervised(
        snap.docs.map((d) => ({ id: d.id, ...d.data() }))
      );
    });

    const colSelfOut = collection(
      db,
      "clients",
      props.clientId,
      "ConsentSelfOutingPrivileges"
    );
    const unsubscribeSelf = onSnapshot(colSelfOut, (snap) => {
      setSelfOutingPrivileges(
        snap.docs.map((d) => ({ id: d.id, ...d.data() }))
      );
    });

    return () => {
      unsubscribeUn();
      unsubscribeSelf();
    };
  }, [props.clientId]);

  //FUNCTIONS

  const updateClientData = async (clientId) => {
    setIsLoading(true);
    try {
      const clientRef = doc(db, "clients", clientId);
      const clientRefPreAdmission = doc(
        db,
        "preAdmissionAssessments",
        clientId
      );

      await setDoc(
        clientRef,
        {
          primaryAddiction: primaryAddiction,
          secondaryAddiction: secondaryAddiction,
          allergy: allergy,
          drugAllergy: drugAllergy,
          currentLegalInvolvement: currentLegalInvolvement,
          otherMajorHealthIssues: otherMajorHealthIssues,
          primaryAddictionOther: primaryAddictionOther,
          secondaryAddictionOther: secondaryAddictionOther,
          allergyOther: allergyOther,
          drugAllergyOther: drugAllergyOther,
        },
        { merge: true }
      );

      // Ajout de la mise à jour pour clientRefPreAdmission
      await setDoc(
        clientRefPreAdmission,
        {
          primaryAddiction: primaryAddiction,
          addictionOther: primaryAddictionOther,
          secondaryAddiction: secondaryAddiction,
          secondaryAddictionOther: secondaryAddictionOther,
        },
        { merge: true }
      );
      setIsModified(false);

      setIsLoading(false);

      showCustomToast("Clinical informations successfully updated!", "success");
    } catch (error) {
      console.error("Error updating informations: ", error);
      setIsLoading(false);

      showCustomToast(`Error updating informations: ${error}`, "error");
    }
  };

  const fetchTreatmentPlan = (clientId) => {
    const treatmentPlanRef = doc(db, "treatmentPlans", clientId);

    // Écouter les modifications du traitement
    const unsubscribeTreatmentPlan = onSnapshot(
      treatmentPlanRef,
      (treatmentPlanSnap) => {
        if (treatmentPlanSnap.exists()) {
          const treatmentPlanData = treatmentPlanSnap.data();
          setPresentingIssues(treatmentPlanData.presentingIssues);
          setLongTermGoals(treatmentPlanData.longTermGoals);
          setTreatmentPlanCreationDate(treatmentPlanData.createdAt);
          setTreatmentPlanCreationBy(treatmentPlanData.createdBy);
          setReviewDone(treatmentPlanData.reviewDone);
          setReviewDoneAt(treatmentPlanData.reviewDoneAt);
          setReviewDoneBy(treatmentPlanData.reviewDoneBy);
        } else {
          console.error("Treatment plan not found");
          setPresentingIssues("");
          setLongTermGoals("");
          setTreatmentPlanCreationDate(null);
          setTreatmentPlanCreationBy("");
          setReviewDone(false);
          setReviewDoneAt("");
          setReviewDoneBy("");
        }
      },
      (error) => {
        console.error("Error fetching treatment plan:", error);
      }
    );

    // Écouter les modifications des objectifs
    const objectivesRef = collection(treatmentPlanRef, "objectives");
    const unsubscribeObjectives = onSnapshot(
      objectivesRef,
      (objectivesSnapshot) => {
        const objectives = [];
        objectivesSnapshot.forEach((objectiveDoc) => {
          objectives.push({ id: objectiveDoc.id, ...objectiveDoc.data() });
        });

        setObjectives(objectives);
      },
      (error) => {
        console.error("Error fetching objectives:", error);
      }
    );

    // Retourner une fonction de nettoyage pour se désabonner des listeners
    return () => {
      unsubscribeTreatmentPlan();
      unsubscribeObjectives();
    };
  };

  function formatDate(timestamp) {
    if (!timestamp || !timestamp.seconds) return "";

    const milliseconds =
      timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000;
    const date = new Date(milliseconds);

    if (isNaN(date)) return "";

    return format(date, "d MMMM yyyy"); // "d" pour le jour, "MMMM" pour le mois en texte, "yyyy" pour l'année
  }

  //USE EFFECT

  useEffect(() => {
    // Remplacez 'clientId' par l'ID du client pour lequel vous souhaitez récupérer le treatmentPlan
    const unsubscribe = fetchTreatmentPlan(props.clientId);

    // Se désabonner lors du démontage du composant
    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    setPrimaryAddiction(props.primaryAddiction || "");
    setPrimaryAddictionOther(props.addictionOther || "");
    setSecondaryAddiction(props.secondaryAddiction || "");
    setAllergy(props.allergy || "");
    setDrugAllergy(props.drugAllergy || "");
    setCurrentLegalInvolvement(props.currentLegalInvolvement || "");
    setOtherMajorHealthIssues(props.otherMajorHealthIssues || "");
    setSecondaryAddictionOther(props.secondaryAddictionOther || "");
    setDrugAllergyOther(props.drugAllergyOther || "");
    setAllergyOther(props.allergyOther || "");
  }, [
    props.primaryAddiction,
    props.addictionOther,
    props.secondaryAddiction,
    props.allergy,
    props.drugAllergy,
    props.currentLegalInvolvement,
    props.otherMajorHealthIssues,
    props.primaryAddictionOther,
    props.secondaryAddictionOther,
    props.allergyOther,
    props.drugAllergyOther,
  ]);

  const handleDischargeRowKeyDown = (event, handler) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handler();
    }
  };

  const renderDischargeDocumentsHeader = () => (
    <div className="clinical-documents-table-header" aria-hidden="true">
      <div>Name of document</div>
      <div>Signed</div>
      <div>Actions</div>
    </div>
  );

  const renderDischargeDocumentRow = ({
    title,
    signed,
    date,
    onOpen,
    onEdit,
    onAdd,
  }) => (
    <div
      className="clinical-documents-standard-row"
      onClick={signed ? onOpen : onAdd}
      onKeyDown={(event) =>
        handleDischargeRowKeyDown(event, signed ? onOpen : onAdd)
      }
      role="button"
      tabIndex={0}
    >
      <div className="clinical-documents-row-title">{title}</div>
      <div className="clinical-documents-row-signed">
        <CheckWithDate checked={!!signed} content={signed ? date : ""} />
      </div>
      <div className="clinical-documents-row-actions">
        {signed ? (
          <>
            <button
              type="button"
              className="clinical-documents-row-action-button"
              onClick={(event) => {
                event.stopPropagation();
                onOpen();
              }}
            >
              Open / print
            </button>
            {onEdit && (
              <button
                type="button"
                className="clinical-documents-row-action-button clinical-documents-row-edit-button"
                onClick={(event) => {
                  event.stopPropagation();
                  onEdit();
                }}
              >
                Edit
              </button>
            )}
          </>
        ) : (
          <button
            type="button"
            className="clinical-documents-add-button"
            onClick={(event) => {
              event.stopPropagation();
              onAdd();
            }}
            aria-label={`Add ${title}`}
          >
            +
          </button>
        )}
      </div>
    </div>
  );

  return (
    <div className="tab-container-white">
      <Modal
        open={openUploadBioPsycho2}
        onClose={handleCloseBioPsychoForm2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalUploadPdf}>
          <UpdloaderPsychosocial
            {...props}
            closemodal={handleCloseBioPsychoForm2}
          />
        </Box>
      </Modal>

      <Modal
        open={openUploadTreatmentPlan}
        onClose={handleCloseTreatmentPlan2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalUploadPdf}>
          <UpdloaderTreatmentPlan
            {...props}
            closemodal={handleCloseTreatmentPlan2}
          />
        </Box>
      </Modal>

      <Modal
        open={openTreatmentPlanForm}
        onClose={handleCloseTreatmentPlanForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral}>
          <AddTreatmentPlan
            {...props}
            clientId={props.clientId}
            closemodal={handleCloseTreatmentPlanForm}
            initialData={corePlanData}
          />
        </Box>
      </Modal>
      <StandardDrawer
        open={openGeneralLiabilityForm}
        onClose={handleCloseGeneralLiabilityForm}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <AddGeneralLiabilityForm
          closemodal={handleCloseGeneralLiabilityForm}
          clientId={props.clientId}
        />
      </StandardDrawer>

      <StandardDrawer
        open={openInformedConsentForm}
        onClose={handleCloseInformedConsentForm}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <AddInformedConsentForm
          clientId={props.clientId}
          closemodal={handleCloseInformedConsentForm}
        />
      </StandardDrawer>

      <StandardDrawer
        open={openPsychiatricServicesForm}
        onClose={handleClosePsychiatricServicesForm}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <AddPsychiatristServicesForm
          closemodal={handleClosePsychiatricServicesForm}
          clientId={props.clientId}
        />
      </StandardDrawer>

      <StandardDrawer
        open={openConfidentialityPolicyForm}
        onClose={handleCloseConfidentialityPolicyForm}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <AddConfidentialityPolicy
          closemodal={handleCloseConfidentialityPolicyForm}
          clientId={props.clientId}
        />
      </StandardDrawer>

      <Modal
        open={openClientRightsForm}
        onClose={handleCloseClientRightsForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral}>
          <AddClientRights
            closemodal={handleCloseClientRightsForm}
            clientId={props.clientId}
          />
        </Box>
      </Modal>

      <Modal
        open={openAgressionPolicyForm}
        onClose={handleCloseAgressionPolicyForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral}>
          <AddAgressionControl
            closemodal={handleCloseAgressionPolicyForm}
            clientId={props.clientId}
          />
        </Box>
      </Modal>

      <StandardDrawer
        open={openDischargeSummaryForm}
        onClose={handleCloseDischargeSummaryForm}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <AddDischargeReport
          clientId={props.clientId}
          closemodal={handleCloseDischargeSummaryForm}
          dateOfAdmission={props.dateOfAdmission}
        />
      </StandardDrawer>

      <StandardDrawer
        open={openViewDischargeSummaryForm}
        onClose={handleCloseViewDischargeSummaryForm}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <ViewDischargeReport
          {...props}
          closemodal={handleCloseViewDischargeSummaryForm}
        />
      </StandardDrawer>

      <StandardDrawer
        open={openEditDischargeSummaryForm}
        onClose={handleCloseEditDischargeSummaryForm}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <EditDischargeReport
          {...props}
          closemodal={handleCloseEditDischargeSummaryForm}
        />
      </StandardDrawer>

      <StandardDrawer
        open={openBioPsycho3}
        onClose={handleCloseBioPsycho3}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <AddBioPsycho3
          {...props}
          clientId={props.clientId}
          closemodal={handleCloseBioPsycho3}
          dateOfAdmission={props.dateOfAdmission}
        />
      </StandardDrawer>

      <StandardDrawer
        open={openAcaForm}
        onClose={handleCloseAcaForm}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <AddAcaForm
          closemodal={handleCloseAcaForm}
          clientId={props.clientId}
          {...props}
        />
      </StandardDrawer>

      <StandardDrawer
        open={openViewAcaForm}
        onClose={handleCloseViewAcaForm}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <ViewAcaReport {...props} closemodal={handleCloseViewAcaForm} />
      </StandardDrawer>

      <StandardDrawer
        open={openEmergencyDischargeForm}
        onClose={handleCloseEmergencyDischargeForm}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <AddEmergencyDischargeForm
          closemodal={handleCloseEmergencyDischargeForm}
          clientId={props.clientId}
          {...props}
        />
      </StandardDrawer>

      <StandardDrawer
        open={openViewEmergencyDischargeForm}
        onClose={handleCloseViewEmergencyDischargeForm}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <ViewEmergencyDischargeReport
          {...props}
          closemodal={handleCloseViewEmergencyDischargeForm}
        />
      </StandardDrawer>

      <StandardDrawer
        // open={openConsentAndAgreementForUnsupervisedActivity}
        // onClose={handleCloseConsentAndAgreementForUnsupervisedActivity}
        open={openAddUnsupervised}
        onClose={handleCloseAddUnsupervised}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <AddConsentAgreementUnsupervisedActivityGood
          closemodal={handleCloseAddUnsupervised}
          clientId={props.clientId}
          {...props}
        />
      </StandardDrawer>

      <StandardDrawer
        // open={openSelfOutingPrivilege}
        // onClose={handleCloseSelfOutingPrivilege}
        open={openAddSelfOuting}
        onClose={handleCloseAddSelfOuting}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <AddConsentSelfOutingPrivilege
          closemodal={handleCloseAddSelfOuting}
          clientId={props.clientId}
          {...props}
        />
      </StandardDrawer>

      <Modal
        open={openContinuatedTherapySupportForm}
        onClose={handleCloseContinuatedTherapySupportForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral2}>
          <AddContinuatedTherapySupport
            closemodal={handleCloseContinuatedTherapySupportForm}
            clientId={props.clientId}
          />
        </Box>
      </Modal>

      <div className="container-main-plan margin-bottom-2 clinical-documents-card">
        <div className="tab-container-title">Clinical Information</div>
        <div className="tab-form-container">
          <div className="column-div">
            <DropDownComponent
              api="addictions"
              title="Primary addiction"
              value={primaryAddiction}
              onChange={handlePrimaryAddictionChange}
            />

            {primaryAddiction === "Other" ? (
              <InputComponent
                title="If other, describe"
                width="150px"
                value={primaryAddictionOther}
                onChange={handlePrimaryAddictionOther}
              />
            ) : (
              ""
            )}
          </div>
          <div className="column-div">
            <DropDownComponent
              api="addictions"
              title="Secondary addiction"
              value={secondaryAddiction}
              onChange={handleSecondaryAddictionChange}
            />
            {secondaryAddiction === "Other" ? (
              <InputComponent
                title="If other, describe"
                width="150px"
                value={secondaryAddictionOther}
                onChange={handleSecondaryAddictionOther}
              />
            ) : (
              ""
            )}
          </div>
          <div className="column-div">
            <DropDownComponent
              api="allergies"
              title="Allergy"
              value={allergy}
              onChange={handleAllergyChange}
            />
            {allergy === "Other" ? (
              <InputComponent
                title="If other, describe"
                width="150px"
                value={allergyOther}
                onChange={handleAllergyOther}
              />
            ) : (
              ""
            )}
          </div>

          <div className="column-div">
            <InputComponent
              title="Drug allergy"
              width="150px"
              value={drugAllergy}
              onChange={handleDrugAllergyChange}
            />
          </div>
        </div>
      </div>

      {/* <div className="tab-form-container"> */}
      <div className="container-main-plan margin-bottom-2 clinical-documents-card">
        {props.dateOfAdmission ? (
          <div className="tab-form-container bio-psycho-upload-layout clinical-document-upload-card">
            <div className="bio-psycho-upload-actions">
              <span className="bio-psycho-upload-label">
                Biopsychosocial assessment
              </span>
              <div>
                <Button variant="contained" onClick={handleOpenBioPsycho3}>
                  OPEN BIOPSYCHOSOCIAL ASSESSMENT
                </Button>
                <Chip
                  label={bioStatus.label}
                  size="medium"
                  sx={{
                    backgroundColor: bioStatus.color,
                    color: "#fff",
                    fontWeight: 700,
                  }}
                />
              </div>
            </div>
            <div className="bio-psycho-upload-panel">
              <UploaderBioPsychoModern {...props} />
            </div>
          </div>
        ) : (
          <div className="error-discharge-message">
            Unable to add BioPsychosocial & treatment form if the client is not
            admitted.
          </div>
        )}
        {/* </div> */}
      </div>

      <div className="container-main-plan margin-bottom-2 clinical-documents-card">
        <div className="tab-form-container bio-psycho-upload-layout treatment-plan-upload-layout clinical-document-upload-card">
          <div className="bio-psycho-upload-actions">
            <span className="bio-psycho-upload-label">Treatment plan</span>
            <div>
              <Button variant="contained" onClick={handleOpenTreatmentPlanForm}>
                OPEN TREATMENT PLAN
              </Button>
            </div>
          </div>
          <div className="bio-psycho-upload-panel">
            <UploaderTreatmentPlanModern {...props} />
          </div>
        </div>
      </div>

      <div className="container-main-plan margin-bottom-2 clinical-documents-card clinical-documents-consent-card">
        {/* <div className="tab-container-title margin-title">Discharge forms</div> */}
        {props.dateOfAdmission ? (
          <div className="tab-form-container-bottom clinical-documents-lines">
            {renderDischargeDocumentsHeader()}
            {renderDischargeDocumentRow({
              title: "Discharge summary / Report",
              signed: dischargeReportOkState,
              date: formatDate(dischargeReportDateState),
              onOpen: handleOpenViewDischargeSummaryForm,
              onEdit: handleOpenEditDischargeSummaryForm,
              onAdd: handleOpenDischargeSummaryForm,
            })}
            {renderDischargeDocumentRow({
              title: "Leave Against Clinical Advice (ACA)",
              signed: props.acaReportOk,
              date: formatDate(props.acaReportDateSigned),
              onOpen: handleOpenViewAcaForm,
              onAdd: handleOpenAcaForm,
            })}
            {renderDischargeDocumentRow({
              title: "Emergency Discharge",
              signed: props.EmergencyDischargeOk,
              date: formatDate(props.EmergencyDischargeDateSigned),
              onOpen: handleOpenViewEmergencyDischargeForm,
              onAdd: handleOpenEmergencyDischargeForm,
            })}

            {/* <div className="form-line-button">
              <FormLineConsAgreeUnsupervised
                title="Consent and Agreement Form for Unsupervised Off-Site Activities"
                color="1"
                viewButton={props.ConsentAgreementUnsupervisedActivitiesOk}
                signed={props.ConsentAgreementUnsupervisedActivitiesOk}
                date={formatDate(
                  props.ConsentAgreementUnsupervisedActivitiesOkSigned
                )}
                {...props}
              />
              {props.ConsentAgreementUnsupervisedActivitiesOk ? (
                ""
              ) : (
                <AddButtonRound
                  handleOpen={
                    handleOpenConsentAndAgreementForUnsupervisedActivity
                  }
                />
              )}
            </div>

            <div className="form-line-button">
              <FormLineOutingPrivilege
                title="Consent and Agreement Form for Self-Outing Privilege"
                color="1"
                viewButton={props.ConsentSelfOutingPrivilegeOk}
                signed={props.ConsentSelfOutingPrivilegeOk}
                date={formatDate(props.ConsentSelfOutingPrivilegeDateSigned)}
                {...props}
              />
              {props.ConsentSelfOutingPrivilegeOk ? (
                ""
              ) : (
                <AddButtonRound handleOpen={handleOpenSelfOutingPrivilege} />
              )}
            </div> */}

            {/* Modal de visualisation Unsupervised */}
            <Modal
              open={openViewUnsupervised}
              onClose={handleCloseViewUnsupervised}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={styleModalGeneral2}>
                <ViewConsentAgreementUnsupervisedActivities
                  clientId={props.clientId}
                  consentId={selectedUnsupervisedId}
                  closemodal={handleCloseViewUnsupervised}
                />
              </Box>
            </Modal>

            {/* {consentsUnsupervised.map((item) => (
              <FormLineConsAgreeUnsupervised
                key={item.id}
                title="Consent and Agreement Form for Unsupervised Off-Site Activities"
                signed={!!item.signedAt}
                date={formatDate(item.signedAt)}
                onView={() => handleOpenViewUnsupervised(item.id)}
              />
            ))}
            <AddButtonRound handleOpen={handleOpenAddUnsupervised} />          

            

            {selfOutingPrivileges.map((item) => (
              <FormLineOutingPrivilege
                key={item.id}
                title="Consent and Agreement Form for Self-Outing Privilege"
                signed={!!item.signedAt}
                date={formatDate(item.signedAt)}
                onView={() => handleOpenViewSelfOuting(item.id)}
              />
            ))}
            <AddButtonRound handleOpen={handleOpenAddSelfOuting} /> */}

            {/* ——— Consent & Unsupervised Off-Site Activities ——— */}
            <div className="clinical-documents-consent-list">
              <div className="clinical-documents-consent-section">
                <h4 className="clinical-documents-consent-title">
                  Consent & Agreement Form for Unsupervised Off-Site Activities
                </h4>

                {consentsUnsupervised.length === 0 ? (
                  <div className="clinical-documents-empty-state">
                    Aucun formulaire soumis.
                  </div>
                ) : (
                  consentsUnsupervised.map((item) => (
                    <FormLineConsAgreeUnsupervised
                      key={item.id}
                      id={item.id}
                      title={item.outingPurpose}
                      signed={!!item.signedOn}
                      date={formatDate(item.signedOn)}
                      onView={() => handleOpenViewUnsupervised(item.id)}
                    />
                  ))
                )}

                <div
                  onClick={handleOpenAddUnsupervised}
                  role="button"
                  tabIndex={0}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    border: "1px solid black",
                    borderRadius: "10px",
                    marginTop: "20px",
                    marginLeft: "30px",
                    padding: "5px 10px",
                    backgroundColor: "#1976d2",
                    color: "white",
                    fontWeight: "600",
                    cursor: "pointer", // indique que c'est cliquable
                    userSelect: "none", // évite la sélection de texte au clic
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      handleOpenAddUnsupervised();
                    }
                  }}
                >
                  <span style={{ marginRight: "10px" }}>ADD FORM</span>
                  {/* <AddButtonRound handleOpen={handleOpenAddUnsupervised} /> */}
                </div>
              </div>

              {/* ——— Consent & Self-Outing Privilege ——— */}
              <div className="clinical-documents-consent-section">
                <h4 className="clinical-documents-consent-title">
                  Consent & Agreement Form for Self-Outing Privilege
                </h4>

                {selfOutingPrivileges.length === 0 ? (
                  <div
                    style={{
                      fontStyle: "italic",
                      color: "#666",
                      marginTop: "10px",
                      marginLeft: "10px",
                      marginBottom: "20px",
                    }}
                  >
                    Aucun formulaire soumis.
                  </div>
                ) : (
                  selfOutingPrivileges.map((item) => (
                    <FormLineOutingPrivilege
                      key={item.id}
                      id={item.id}
                      title={item.outingPurpose} // déjà affiché en entête
                      signed={!!item.signedOn}
                      date={formatDate(item.signedOn)}
                      onView={() => handleOpenViewSelfOuting(item.id)}
                    />
                  ))
                )}

                <div style={{ marginTop: 8 }}>
                  <div
                    onClick={handleOpenAddSelfOuting}
                    role="button"
                    tabIndex={0}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      border: "1px solid black",
                      borderRadius: "10px",
                      marginTop: "20px",
                      marginLeft: "30px",
                      padding: "5px 10px",
                      backgroundColor: "#1976d2",
                      color: "white",
                      fontWeight: "600",
                      cursor: "pointer", // indique que c'est cliquable
                      userSelect: "none", // évite la sélection de texte au clic
                    }}
                    onKeyPress={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        handleOpenAddSelfOuting();
                      }
                    }}
                  >
                    <span style={{ marginRight: "10px" }}>ADD FORM</span>
                    {/* <AddButtonRound handleOpen={handleOpenAddUnsupervised} /> */}
                  </div>
                  {/* <AddButtonRound handleOpen={handleOpenAddSelfOuting} /> */}
                </div>
              </div>
            </div>

            {/* Modal de visualisation Self-Outing */}
            <Modal
              open={openViewSelfOuting}
              onClose={handleCloseViewSelfOuting}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={styleModalGeneral2}>
                <ViewSelfoutingPrivileges
                  clientId={props.clientId}
                  privilegeId={selectedSelfOutingId}
                  closemodal={handleCloseViewSelfOuting}
                />
              </Box>
            </Modal>
          </div>
        ) : (
          <div className="error-discharge-message">
            Unable to sign Discharge form if the client is not admitted.
          </div>
        )}
      </div>

      <div className="button-container-form-gi">
        <Button
          variant="contained"
          onClick={() => updateClientData(props.clientId)}
          style={
            isModified && !isLoading
              ? {
                  backgroundColor: "red",
                  color: "white",
                  marginLeft: "15px",
                }
              : {
                  backgroundColor: "#1565C0",
                  color: "white",
                  marginLeft: "15px",
                }
          }
          disabled={isLoading}
          sx={{
            height: "40px",
            width: "220px",
            marginLeft: "25px",
            marginRight: "30px",
          }}
        >
          {isLoading
            ? "SAVING MODIFICATIONS..."
            : isModified
            ? "CLICK TO SAVE"
            : "SAVE MODIFICATIONS"}
        </Button>
      </div>
    </div>
  );
}

export default ClinicalInformations;
